import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cbb9de6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Data Visualization")
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "selectionRow" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Graph")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("MeterID")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("High voltage")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Low voltage")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Add Graph ")
const _hoisted_9 = { style: {"min-height":"40vh"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Add Graph")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("URL")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Add Graph")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_text, { style: {"font-size":"1.5rem"} }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_ion_grid, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_item, { class: "select-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "label" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select, {
                              interface: "popover",
                              modelValue: _ctx.selectedGraph,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGraph) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graphs, (graph, index) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: index,
                                    value: graph
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(graph.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              disabled: _ctx.selectedGraph.id == 0,
                              size: "small",
                              fill: "clear",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.favourizeGraph()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  color: "warning",
                                  icon: _ctx.selectedGraph.favourite ? _ctx.star : _ctx.starOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_ion_button, {
                              disabled: _ctx.selectedGraph.id == 0,
                              size: "small",
                              fill: "clear",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteGraph(_ctx.selectedGraph.id)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  color: "danger",
                                  icon: _ctx.trashOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "label" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          color: "medium",
                          fill: "clear",
                          size: "default",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectMeterIdOpen(true, $event)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.selectedMeter ? _ctx.selectedMeter.id : 'No meters available') + "   ", 1),
                            _createVNode(_component_ion_icon, { icon: _ctx.caretDownOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_popover, {
                          "is-open": _ctx.isOpenSelectMeterId,
                          event: _ctx.event,
                          "css-class": "larger-popover",
                          onDidDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSelectMeterIdOpen(false)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meters, (meter, index) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                    onClick: 
                                            () => {
                                                _ctx.selectedMeter = meter;
                                                _ctx.setSelectMeterIdOpen(false);
                                            }
                                        ,
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        color: "medium",
                                        fill: "clear",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(meter.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_chip, { outline: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            icon: _ctx.arrowUpCircle,
                                            color: _ctx.Helpers.voltageOutOfRange(meter.max) ? 'danger' : 'dark'
                                          }, null, 8, ["icon", "color"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(Math.round(meter.max)) + "V", 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_chip, { outline: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            icon: _ctx.arrowDownCircle,
                                            color: _ctx.Helpers.voltageOutOfRange(meter.min) ? 'danger' : 'dark'
                                          }, null, 8, ["icon", "color"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(Math.round(meter.min)) + "V", 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["is-open", "event"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.highVoltage,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.highVoltage) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_radio, {
                                  slot: "end",
                                  value: true
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_radio, {
                                  slot: "end",
                                  value: false
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { style: {"display":"grid","justify-content":"right"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          fill: "clear",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setOpen(true)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              color: "warning",
                              icon: _ctx.addOutline
                            }, null, 8, ["icon"]),
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "default", {
                      graphSrc: _ctx.graphURL,
                      args: _ctx.args
                    }, undefined, true)
                  ]),
                  _createVNode(_component_ion_modal, {
                    "is-open": _ctx.isOpenRef,
                    "css-class": "my-custom-class",
                    onDidDismiss: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setOpen(false)))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("form", {
                        onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.createGraph()), ["prevent"]))
                      }, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { style: {"font-size":"3em"} }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.form.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.name) = $event)),
                              name: "name",
                              type: "text",
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.form.url,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.url) = $event)),
                              name: "url",
                              type: "text",
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, { type: "submit" }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              type: "button",
                              color: "warning",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setOpen(false)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 32)
                    ]),
                    _: 1
                  }, 8, ["is-open"])
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 64))
}